import { Injectable } from "@angular/core";
import { BaseStyle } from "primeng/base";
import { Ankaadia } from "../../theme/preset";

@Injectable({ providedIn: "root" })
export class PageheaderStyle extends BaseStyle {
  override name = "pageheader";

  override theme = ({ dt }: any): string => `
    .ui-pageheader {
      display: flex;
      align-items: end;
      padding: ${dt("pageheader.padding")};
      gap: ${dt("pageheader.gap")};
      background: ${dt("pageheader.background")};
      color: ${dt("pageheader.color")};
    }

    .ui-pageheader-header {
      display: flex;
      flex-direction: column;
      gap: ${dt("pageheader.header.gap")};
    }

    .ui-pageheader-caption {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-size: ${dt("pageheader.caption.font.size")};
      line-height: ${dt("pageheader.caption.font.leading")};
      font-weight: ${dt("pageheader.caption.font.weight")};
    }

    .ui-pageheader-description {
      font-size: ${dt("pageheader.description.font.size")};
      line-height: ${dt("pageheader.description.font.leading")};
      font-weight: ${dt("pageheader.description.font.weight")};
    }

    .ui-pageheader-controls {
      margin-inline-start: auto;
      min-width: fit-content;
    }

    @media (width < ${Ankaadia.semantic.breakpoint.mobile}) {
      .ui-pageheader {
        align-items: start;
      }

      .ui-pageheader-caption {
        font-size: ${dt("pageheader.caption.mobile.font.size")};
        line-height: ${dt("pageheader.caption.mobile.font.leading")};
        font-weight: ${dt("pageheader.caption.mobile.font.weight")};
      }

      .ui-pageheader-description {
        font-size: ${dt("pageheader.description.mobile.font.size")};
        line-height: ${dt("pageheader.description.mobile.font.leading")};
        font-weight: ${dt("pageheader.description.mobile.font.weight")};
      }

      .ui-pageheader-controls .p-button {
        padding-block: ${dt("button.sm.padding.y")};
        padding-inline: ${dt("button.sm.padding.x")};
        width: ${dt("button.sm.icon.only.width")};
      }
      
      .ui-pageheader-controls .button-mobile-label.p-button {
        width: 100%;
      }
        
      .ui-pageheader-controls .p-button-icon {
        font-size: ${dt("button.sm.font.size")};
      }

            
      .ui-pageheader-controls .button-mobile-label .p-button-label {
        display: initial;
      }
      
      .ui-pageheader-controls .p-button-label {
        display: none;
      }
    }
  `;

  override classes = {
    root: "ui-pageheader",
    header: "ui-pageheader-header",
    caption: "ui-pageheader-caption",
    description: "ui-pageheader-description",
    controls: "ui-pageheader-controls",
  };
}
